import { useBookmarks } from './use-bookmarks';
import { useToast } from '../use-toast';
import { ResourceBookmarkToastProps } from '../../../components/toast/resource-table/resource-bookmark-toast';

export const useBookmarkToastMessage = () => {
  const { bookmarkResource, deleteBookmark } = useBookmarks();
  const { removeToastMessage } = useToast();

  const handleUndoClick = (toastProps: Omit<ResourceBookmarkToastProps, 'text'>) => {
    toastProps.isBookmarked
      ? deleteBookmark(toastProps.resourceId)
      : bookmarkResource(toastProps.resourceId);

    removeToastMessage(toastProps.toastMessageId);
  };

  return {
    handleUndoClick,
  };
};
